import { Text } from '@epam/promo';

type VersionDisplayTextProps = {
  versionText: string;
};

export const VersionDisplayText = ({
  versionText,
}: VersionDisplayTextProps) => (
  <Text color="gray80" fontSize="16" lineHeight="18">
    {versionText}
  </Text>
);
